import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api/tenant-portal`

async function jsonOrThrow(response, fallback) {
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    const error = new Error(err.error || fallback)
    error.status = response.status
    throw error
  }
  return response.json()
}

export async function getPortalOverview() {
  return jsonOrThrow(await fetch(`${API_BASE}/overview`), 'Error al cargar el portal')
}

export async function getPortalContract(contractId) {
  return jsonOrThrow(await fetch(`${API_BASE}/contracts/${contractId}`), 'Error al cargar el contrato')
}

export async function getPortalPayments(contractId, year, month) {
  const query = year && month ? `?year=${year}&month=${month}` : ''
  return jsonOrThrow(await fetch(`${API_BASE}/contracts/${contractId}/payments${query}`), 'Error al cargar los pagos')
}

export async function getPortalStatements(contractId) {
  return jsonOrThrow(await fetch(`${API_BASE}/contracts/${contractId}/statements`), 'Error al cargar los estados de cuenta')
}

// El PDF se descarga con la cookie de sesión (navegación directa), no desde /uploads.
export const statementDownloadUrl = (statementId) => `${API_BASE}/statements/${statementId}/download`

// --- Solicitudes de mantenimiento ---
export async function getPortalTickets(contractId) {
  return jsonOrThrow(await fetch(`${API_BASE}/contracts/${contractId}/tickets`), 'Error al cargar las solicitudes')
}

export async function createPortalTicket(contractId, { category, description, urgency, file }) {
  const formData = new FormData()
  formData.append('category', category)
  formData.append('description', description)
  formData.append('urgency', urgency)
  if (file) formData.append('file', file)
  return jsonOrThrow(await fetch(`${API_BASE}/contracts/${contractId}/tickets`, { method: 'POST', body: formData }), 'Error al enviar la solicitud')
}

export async function getPortalTicket(ticketId) {
  return jsonOrThrow(await fetch(`${API_BASE}/tickets/${ticketId}`), 'Error al cargar la solicitud')
}

export async function sendPortalTicketMessage(ticketId, { text, confirm, file }) {
  const formData = new FormData()
  formData.append('text', text || '')
  if (confirm) formData.append('confirm', 'true')
  if (file) formData.append('file', file)
  return jsonOrThrow(await fetch(`${API_BASE}/tickets/${ticketId}/messages`, { method: 'POST', body: formData }), 'Error al enviar el mensaje')
}

// --- Cuenta ---
export async function getPortalAccount() {
  return jsonOrThrow(await fetch(`${API_BASE}/account`), 'Error al cargar tu cuenta')
}

export async function updatePortalAccount(payload) {
  return jsonOrThrow(await fetch(`${API_BASE}/account`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  }), 'Error al guardar tus datos')
}

export async function changePortalPassword(currentPassword, newPassword) {
  return jsonOrThrow(await fetch(`${API_BASE}/account/change-password`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ currentPassword, newPassword }),
  }), 'Error al cambiar la contraseña')
}

export async function logoutAllPortalSessions() {
  return jsonOrThrow(await fetch(`${API_BASE}/account/logout-all`, { method: 'POST' }), 'Error al cerrar las sesiones')
}

// Resumen consolidado de todas las naves del inquilino (saldo vencido, por vencer y próximo vencimiento).
export async function getPortalSummary() {
  return jsonOrThrow(await fetch(`${API_BASE}/summary`), 'Error al cargar el resumen')
}